import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import { makeGetRequest, makePostRequest } from 'utils/api'
import { currentDate, convertToMuiDate } from 'utils/helpers'
import urls from 'utils/urls'

export default function CreateOperationForm({ fetchOperations, weekNo, setOpenForm, setRow, row }) {
  const [open, setOpen] = useState(true)
  const [recette, setRecette] = useState([])
  const [selectedMeal, setSelectedMeal] = useState({})

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      Meal: row?.Meal ? row.Meal : '',
      RecetteId: '',
      Servir: '',
      Date: row?.Date ? convertToMuiDate(row.Date) : currentDate(),
    },
  })
  useEffect(() => {
    fetchRecettes()

    setValue('Meal', row?.Meal ? typeMeal.filter((v) => v.label === row?.Meal)[0] : '')
    setSelectedMeal(row?.Meal ? typeMeal.filter((v) => v.label === row?.Meal)[0] : {})
  }, [])

  const handleClose = () => {
    setOpen(false)
    setOpenForm(false)
    setRow({})
    reset()
  }
  const typeMeal = [
    { label: 'Matin', id: 1 },
    { label: 'Midi', id: 2 },
    { label: 'Après-midi', id: 3 },
    { label: 'Soir', id: 4 },
  ]
  const onSubmit = async (data) => {
    const payload = {
      ...data,
      RecetteId: data.RecetteId.id,
      Meal: data.Meal.label,
    }

    const response = await makePostRequest(urls.planMealOperations, payload, {}, true)
    if (response.status === 201) {
      fetchOperations('', weekNo)
      handleClose()
    }
  }

  const fetchRecettes = async () => {
    const url = urls.getRecettes
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Nom}`, id: v.id, servir: v.Servir })
      })
      setRecette([...filterTypes])
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ bgcolor: 'black !important' }}>Planifier recette</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('RecetteId', j)
                setValue('Servir', j?.servir ? j.servir : '')
              }}
              label="Recette"
              data={recette}
              name="RecetteId"
              required={true}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Servir"
              label="Personnes"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Date"
              label="Date"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Meal', j)
                setSelectedMeal(j)
              }}
              label="Meal"
              data={typeMeal}
              name="Meal"
              required={true}
              selectedValue={selectedMeal}
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
